// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb40: FC<LightBulb40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20 36.667c-.935 0-1.73-.327-2.382-.98-.653-.652-.98-1.446-.98-2.381h6.723c0 .935-.326 1.729-.979 2.382-.653.652-1.447.979-2.382.979Zm-6.722-5.64V28.25h13.444v2.778H13.278ZM13.555 26c-1.86-1.176-3.335-2.68-4.423-4.514C8.044 19.653 7.5 17.611 7.5 15.361c0-3.417 1.23-6.354 3.688-8.812C13.646 4.09 16.582 2.86 20 2.86s6.354 1.23 8.813 3.688C31.27 9.007 32.5 11.944 32.5 15.36c0 2.25-.54 4.292-1.618 6.125-1.079 1.833-2.558 3.338-4.438 4.514H13.557Zm.945-2.778h11.028a9.56 9.56 0 0 0 3.076-3.402 9.234 9.234 0 0 0 1.118-4.459c0-2.685-.949-4.977-2.847-6.875C24.977 6.588 22.685 5.64 20 5.64c-2.685 0-4.977.949-6.875 2.847-1.898 1.898-2.847 4.19-2.847 6.875 0 1.593.372 3.079 1.118 4.459a9.468 9.468 0 0 0 3.104 3.402Z" />
        </svg>
    );
};

export default LightBulb40;
